import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "h-fit flex gap-4 justify-between"
};
const _hoisted_2 = {
  class: "grow max-w-[160px] flex flex-col gap-10"
};
const _hoisted_3 = {
  class: "flex items-center gap-3 mx-auto"
};
const _hoisted_4 = {
  class: "flex flex-col gap-3 border-l-2 border-second-50 pl-4"
};
const _hoisted_5 = {
  class: "flex items-center gap-3"
};
const _hoisted_6 = {
  class: "py-1 bg-main-10 rounded shadow-weak_material",
  "focus-group": "scheduler-interval-group"
};
const _hoisted_7 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Calendar = _resolveComponent("Calendar");
  const _component_RangeSelector = _resolveComponent("RangeSelector");
  const _component_Toggle = _resolveComponent("Toggle");
  const _component_InputField = _resolveComponent("InputField");
  const _component_FloatingElement = _resolveComponent("FloatingElement");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Calendar, {
    class: "h-fit w-[300px]",
    defaultStyle: false,
    repeatInterval: _ctx.value.interval,
    intervalTime: _ctx.value.repeat && _ctx.value.every ? _ctx.value.every : undefined,
    modelValue: _ctx.value.date,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.value.date = $event)
  }, null, 8, ["repeatInterval", "intervalTime", "modelValue"]), _cache[12] || (_cache[12] = _createElementVNode("div", {
    class: "w-px bg-main-100/10 shrink-0"
  }, null, -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_RangeSelector, {
    modelValue: _ctx.value.hour,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.value.hour = $event),
    range: [0, 23],
    vertical: true,
    normalize: value => value?.toString().padStart(2, 0)
  }, null, 8, ["modelValue", "normalize"]), _cache[8] || (_cache[8] = _createElementVNode("p", null, ":", -1)), _createVNode(_component_RangeSelector, {
    modelValue: _ctx.value.minute,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.value.minute = $event),
    range: [0, 59],
    vertical: true,
    normalize: value => value?.toString().padStart(2, 0)
  }, null, 8, ["modelValue", "normalize"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[9] || (_cache[9] = _createTextVNode(" Repetir ")), _createVNode(_component_Toggle, {
    modelValue: _ctx.value.repeat,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.value.repeat = $event),
    onClick: _cache[4] || (_cache[4] = $event => _ctx.value.repeat = !_ctx.value.repeat)
  }, null, 8, ["modelValue"])]), _createElementVNode("div", {
    class: _normalizeClass(["flex items-center gap-2.5", {
      'opacity-50 pointer-events-none': !_ctx.value.repeat
    }])
  }, [_cache[11] || (_cache[11] = _createTextVNode(" Cada ")), _createElementVNode("span", null, [_createVNode(_component_InputField, {
    modelValue: _ctx.value.every,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.value.every = $event),
    size: "xs",
    placeholder: "",
    type: "number"
  }, null, 8, ["modelValue"])]), _createElementVNode("div", {
    class: "flex items-center gap-1.5 cursor-pointer",
    tabindex: "0",
    onFocus: _cache[6] || (_cache[6] = $event => this.$handleFocusGroup(() => _ctx.showIntervalSelector = false)),
    "focus-group": "scheduler-interval-group",
    onClick: _cache[7] || (_cache[7] = $event => _ctx.showIntervalSelector = !_ctx.showIntervalSelector)
  }, [_createTextVNode(_toDisplayString(_ctx.intervalTime[_ctx.value.interval]) + " ", 1), _cache[10] || (_cache[10] = _createElementVNode("i", {
    class: "icon-chevron-down text-2xs"
  }, null, -1)), _ctx.showIntervalSelector ? (_openBlock(), _createBlock(_component_FloatingElement, {
    key: 0,
    position: {
      top: 4,
      right: 0,
      translateY: true
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intervalTime, (i, key) => {
      return _openBlock(), _createElementBlock("p", {
        key: i,
        class: _normalizeClass(["px-3 py-1 hover:bg-main-50/10 text-xs cursor-pointer", {
          'hidden': key === _ctx.value.interval
        }]),
        onClick: $event => _ctx.value.interval = key
      }, _toDisplayString(i), 11, _hoisted_7);
    }), 128))])]),
    _: 1
  })) : _createCommentVNode("", true)], 32)], 2)])])]);
}